<template>
  <div class="Index">
    <Header id="nav"></Header>
    <div class="main-content">
      <Banner></Banner>
      <Home></Home>
      <div alt="" class="to-top" @click="goTop">
        <p><i class="iconfont iconarrow_up"></i> <span>TOP</span></p>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Banner from "./components/banner.vue";
import Home from "@/views/Index/home/index.vue";

export default {
  name: "Index",
  components: {
    Banner,
    Home
  },
  data() {
    return {};
  },
  mounted() {
     this.$cookie.setCookie('orgId','')
  },
  created() {},
  methods: {
    goTop(){
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  },
};
</script>

<style scoped lang="less">
.main-content{
  // height: 20.80rem;
  background: url(@/assets/image/homeimg.png) center center no-repeat;
  position: relative;
  overflow-x: hidden;
  padding-bottom: 1.5rem;
}
.to-top {
  position: absolute;
  bottom: 0.3rem;
  right: 2rem;
  background: #fff;
  width: 0.4rem;
  height: 0.4rem;
  text-align: center;
  border: 0.01rem solid #D0D0D0;
  border-radius: 0.04rem;
  color: #787878;
  font-size: 0.1rem;
  z-index: 20;
  cursor: pointer;
}
.to-top p {
  margin-top: 0.04rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>